export default "__VITE_ASSET__BMACf_Ne__"